import { render } from "./CompanyAddPage.vue?vue&type=template&id=3ddab40b&scoped=true"
import script from "./CompanyAddPage.vue?vue&type=script&lang=js"
export * from "./CompanyAddPage.vue?vue&type=script&lang=js"

import "./CompanyAddPage.vue?vue&type=style&index=0&id=3ddab40b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ddab40b"]])

export default __exports__